import { Component, effect, inject, Renderer2, HostListener, ElementRef, Input } from '@angular/core';
// import { Directive, HostListener, Renderer2, ElementRef } from '@angular/core';

import { SharedSignalsService } from '../../services/shared-signals.service';
import { TranslationService } from '../../services/translation.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionVariable } from '../../enum/session-variable';
import { EnvService } from 'src/app/env.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'taly-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
  providers: [ConfirmationService]
})
export class SiteHeaderComponent {

  transferSignal = inject(SharedSignalsService);
  toggleCurrentLanguage: boolean = false;
  isHeader: boolean = false;
  textDirection: string;
  heaerItems: any = [];
  isMenuOpen = false;
  isWindowResize = false;
  isDarkHeader: boolean = false;
  isActive: Number;
  routeNameToCompare: string;
  isDropDownActive: boolean = false;
  @Input() home;
  currentRoute: string;
  isDropdownOpen: boolean = false;
  menuCtrl = new FormControl();
  dropdownOpen: boolean = false;
  isGreyHeader: boolean = false;

  constructor(public translationService: TranslationService, private storageService: LocalStorageService,
    public envService: EnvService, private router: Router, private activatedRoute: ActivatedRoute, private confirmationService: ConfirmationService, private el: ElementRef, private renderer: Renderer2) {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      this.isDarkHeader = this.transferSignal.darkHeader();
      this.isGreyHeader = this.transferSignal.darkHeader();
      this.heaerItems = [];
      setTimeout(() => {
        this.setHeaderItem();
      }, 100);

    });
  }
  @HostListener('window:scroll', [])


  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const headerElement = document.querySelector('.site-header')
    if (scrollPosition >= 70) {
      this.renderer.addClass(headerElement, 'header-bg-blue');
    } else {
      this.renderer.removeClass(headerElement, 'header-bg-blue');
    }
  }
  onDropdownOpen() {
    this.isDropdownOpen = true;
  }

  onDropdownClose() {
    this.isDropdownOpen = false;
  }
  isHovered: boolean = false;

  ngOnInit(): void {

    const headerElement = document.querySelector('.site-header')
    this.menuCtrl?.patchValue(location?.pathname);
    this.router.events.subscribe(() => {
      const currentUrl = this.router.url;      
      const isHomeRoute = currentUrl === '/';
      const iShopeRoute = currentUrl === '/partners/learn-more';
      if (isHomeRoute) {
        this.renderer.addClass(headerElement, 'bg-blue');
        this.renderer.removeClass(headerElement, 'bg-grey');
      } else {
        this.renderer.removeClass(headerElement, 'bg-blue');
        this.renderer.addClass(headerElement, 'bg-grey');
      }
      if (iShopeRoute) {
        this.renderer.removeClass(headerElement, 'bg-grey');
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.updateHeaderClass();
      }
    });
  }
  getDarkSrc(): string {
    if (this.isHovered) {
      if (this.isDarkHeader) {
        return 'assets/images/hover-lang-logo.svg'; 
      } else if (this.isGreyHeader) {
        return 'assets/images/hover-lang-logo.svg'; 
      }
    }

    
    if (this.isDarkHeader) {
      return 'assets/images/dark-header-lang-logo.svg'; 
    } else if (this.isGreyHeader) {
      return 'assets/images/dark-header-lang-logo.svg'; 
    } else {
      return 'assets/images/blue-lang.svg';
    }
  }
  getDarkMobSrc(): string {
    if (this.isHovered) {
      if (this.isDarkHeader) {
        return 'assets/images/hover-lang-logo.svg'; 
      } else if (this.isGreyHeader) {
        return 'assets/images/hover-lang-logo.svg'; 
      }
    }

    
    if (this.isDarkHeader) {
      return 'assets/images/dark-header-lang-logo.svg'; 
    } else if (this.isGreyHeader) {
      return 'assets/images/dark-header-lang-logo.svg'; 
    } else {
      return 'assets/images/lang-blue-light.svg';
    }
  }
  getgreySrc(): string {
    if (this.isHovered && this.isGreyHeader) {
      if (this.isGreyHeader) {
        return 'assets/images/hover-lang-logo.svg';
      } else if (this.isGreyHeader) {
        return 'assets/images/hover-lang-logo.svg';
      }
    }


    if (this.isGreyHeader) {
      return 'assets/images/dark-header-lang-logo.svg';
    } else if (this.isGreyHeader) {
      return 'assets/images/dark-header-lang-logo.svg';
    } else {
      return 'assets/images/dark-header-lang-logo.svg';
    }
  }

  updateHeaderClass(): void {
    const headerElement = document.querySelector('.site-header');
    if (this.currentRoute === '/home') {
      this.isActive = null;
    }
  }
  setHeaderItem() {
    this.heaerItems = [
      // [TODO] : as requested on 24 May 2025 from sulaiman we are hiding temparary later will enable, so dont delete this code
      // {
      //   label: this.translationService.getLabelValue('SITE_HEADER.SHOPS'),
      //   link: '/shops'
      // },
      {
        children: [
          {
            label: this.translationService.getLabelValue('SITE_HEADER.LEARN_MORE'),
            link: '/partners'
          },
          {
            label: this.translationService.getLabelValue('SITE_HEADER.SIGNUP_FOR'),
            link: '/partners/sign-up'
          },
          {
            label: this.translationService.getLabelValue('SITE_HEADER.SIGNUP_PARTNERS'),
            link: this.envService.MerchantURL,
            target: '_blank'
          },
          {
            label: this.translationService.getLabelValue('SITE_HEADER.DEVELOPERS'),
            link: this.envService.DocsURL,
            target: '_blank'
          },
        ]
      },
      {
        label: this.translationService.getLabelValue('SITE_HEADER.FAQ'),
        link: this.isGreyHeader ? '/faq-partner' : '/faq-shopper'
      },

      {
        label: this.translationService.getLabelValue('SITE_HEADER.DOWNLOAD'),
        type: 'download',
      },
      // {
      //   label : this.translationService.getLabelValue('SITE_HEADER.LOGIN'),
      //   link : '/h'
      // },
      // { 
      //   label:this.translationService.getLabelValue('SITE_HEADER.SIGNUP'),
      //   link : '/i'
      // },
    ]
  }

  toggleText() {
    this.toggleCurrentLanguage = !this.toggleCurrentLanguage;
    const currentLanguage = this.toggleCurrentLanguage ? 'ar-KW' : 'en-US'
    this.transferSignal.setTextDirection(currentLanguage == 'ar-KW' ? 'rtl' : 'ltr');
    this.storageService.setItem(SessionVariable.LANGUAGE, currentLanguage);
    this.translationService.switchLanguage(currentLanguage);
  }

  navRedirection(data: any, index: any) {
    this.isMenuOpen = false;
    if (data?.type == "download") {
      this.appDownloadPopup();
      return;
    }
    this.menuCtrl?.patchValue(data?.link);
    this.isActive = index;
    if (data?.target) {
      const newTab = window.open(data?.link, '_blank');
    } else {
      this.router.navigate([data?.link], { relativeTo: this.activatedRoute });
    }
  }
  appDownloadPopup() {
    this.confirmationService.confirm({
      accept: () => {
        // this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      }
    });
  }
}
